import moment from 'jalali-moment';
import { DatePicker } from 'jalali-react-datepicker';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import Axios from '../utils/axios';
import { useQuery } from '../utils/hooks';

type ServiceDetail = {
	name: string;
	count: number;
	income: number;
};
type Interval = 'Weekly' | 'Monthly' | 'Daily';
type ReportResponse = {
	totalServiceIncome: number;
	totalServiceCount: number;
	totalPatientCount: number;
	serviceDetailList: ServiceDetail[];
	interval: Interval;
};

export const Report: React.FunctionComponent = () => {
	const routerHistory = useHistory();
	// state for date
	const query = useQuery();
	const [interval, setInterval] = useState<Interval>(
		(query.get('interval') as Interval) || 'Daily'
	);
	const [report, setReport] = useState<ReportResponse | null>(null);
	const queryDate = query.get('date') || moment().format('YYYY-MM-DD');
	const [date, setDate] = useState(queryDate);

	useEffect(() => {
		routerHistory.push(`/report?date=${date}&interval=${interval}`);

		const getData = async () => {
			const response = await Axios.get<ReportResponse>(
				`/report/?date=${date}&interval=${interval}`
			);
			setReport(response.data);
		};
		getData();
	}, [date, interval]);
	// const [sortType, setSortType] = useState<'name' | 'count' | 'income'>('name');
	const [sortDirection, setSortDirection] = useState<'asc' | 'desc'>('asc');

	const sortServiceDetailList = (type: 'count' | 'income') => {
		if (report) {
			const sortedServiceDetailList = report.serviceDetailList.sort((a, b) => {
				if (a[type] > b[type]) {
					return sortDirection === 'asc' ? 1 : -1;
				}
				if (a[type] < b[type]) {
					return sortDirection === 'asc' ? -1 : 1;
				}
				return 1;
			});
			setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
			setReport({
				...report,
				serviceDetailList: sortedServiceDetailList
			});
		}
	};

	return (
		<div className="grid grid-flow-row gap-3 mx-auto mt-5 ">
			{/* callout show today date in farsi */}
			<div
				className="px-4 py-3 mx-3 text-blue-700 bg-blue-100 border border-blue-500 rounded-md shadow tooltip"
				role="alert"
				data-tooltip-target="tooltip-default"
			>
				<p className="text-sm">
					تاریخ امروز:{' '}
					{new Date().toLocaleString('fa', {
						year: 'numeric',
						weekday: 'long',
						month: 'long',
						day: '2-digit',
						hour: 'numeric',
						minute: 'numeric'
					})}
				</p>
			</div>

			<div className="flex flex-row mx-4">
				<label>انتخاب تاریخ: </label>
				<DatePicker
					timePicker={false}
					value={moment(date)}
					className="p-1 mx-3 font-bold text-center rounded shadow"
					onClickSubmitButton={async ({ value }) => {
						const stringDate = value.format('YYYY-MM-DD');
						setDate(stringDate);
					}}
				/>

				<label>انتخاب تواتر: </label>
				<select
					className="p-1 mx-3 font-bold text-center rounded shadow"
					onChange={(e) => {
						setInterval(e.target.value as Interval);
					}}
					value={interval}
				>
					<option value="Daily">روزانه</option>
					<option value="Weekly">هفتگی</option>
					<option value="Monthly">ماهانه</option>
				</select>
			</div>
			<div className="p-3 mx-4 rounded-lg shadow-md bg-warmGray-50 ">
				<div className="flex flex-col sm:flex-row sm:justify-around">
					<ReportField label="مجموع درآمد" value={report?.totalServiceIncome} />
					<ReportField label="تعداد خدمات انجام شده" value={report?.totalServiceCount} />
					<ReportField label="مجموع بیماران" value={report?.totalPatientCount} />
				</div>

				<table className="w-full p-2 mt-5 text-center border shadow bg-warmGray-100">
					<thead>
						<tr>
							<th className="px-4 py-2 border ">نام خدمت</th>
							<th
								className="px-4 py-2 border cursor-pointer"
								onClick={() => sortServiceDetailList('count')}
							>
								تعداد
							</th>
							<th
								className="px-4 py-2 border cursor-pointer"
								onClick={() => sortServiceDetailList('income')}
							>
								درآمد (تومان)
							</th>
						</tr>
					</thead>
					<tbody>
						{report?.serviceDetailList.map((service) => (
							<tr key={service.name} className="odd:bg-warmGray-50">
								<td className="px-4 py-2 border">{service.name}</td>
								<td className="px-4 py-2 border">{service.count.toLocaleString('fa-IR')}</td>
								<td className="px-4 py-2 border">{service.income.toLocaleString('fa-IR')} </td>
							</tr>
						))}
					</tbody>
				</table>
			</div>
		</div>
	);
};

export default Report;

type FieldProps = {
	label: string;
	value?: number;
};

export const ReportField: React.FunctionComponent<FieldProps> = (props) => {
	const newValue = props.value?.toLocaleString('fa-IR');
	return (
		<span className="p-1 my-2 bg-gray-100 rounded shadow-md sm:my-0">
			<label>{props.label}:</label>
			<span className="mx-3 font-bold text-center rounded ">{newValue}</span>
		</span>
	);
};
